import Vue from 'vue'
import VbuyEndPopup from './vbuy-end-popup'

let VbuyEndPopupTem = Vue.extend(VbuyEndPopup)
let instance
let vbuyEndPopup = options => {
  if (!instance) {
    instance = new VbuyEndPopupTem({
      propsData: {
        ...options
      }
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }
  // 这里获取数据
  instance.show = true
}
vbuyEndPopup.close = () => {
  instance && (instance.show = false)
}
export default vbuyEndPopup
